module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/change_mobile-9a08ae4541967078880c5cf1b7109596.png";